(function(){
  'use strict';

  if (window.__ganarMasAssetLoaded) {
    if (typeof window.__initGanarMas === 'function') window.__initGanarMas();
    return;
  }

  window.__ganarMasAssetLoaded = true;

  function safeLog() {
    try {
      console.log.apply(console, ['[GANAMAS]'].concat(Array.prototype.slice.call(arguments)));
    } catch(e) {}
  }

  function parseConfig(root) {
    const configEl = root.querySelector('[data-ganamas-config]');
    if (!configEl) return {};

    try {
      return JSON.parse(configEl.textContent || '{}');
    } catch (e) {
      console.warn('[GANAMAS] Invalid config JSON', e);
      return {};
    }
  }

  function resolveCartForm(root) {
    const closestForm = root.closest('form.cart');
    if (closestForm) return closestForm;

    const drawer = root.closest('[data-drawer="drawer-cart"]');
    if (drawer) return drawer.querySelector('form.cart');

    return null;
  }

  function resolveQuickOrderCustomerId(config) {
    const associateInput = document.querySelector('[purchase-order-associate]');
    return (associateInput && associateInput.value) || config.customerId || null;
  }

  function interpolateMessage(template, values) {
    return String(template || '')
      .replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function(_, key) {
        return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : '';
      })
      .replace(/__([a-zA-Z0-9_]+)__/g, function(_, key) {
        return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : '';
      });
  }

  function formatCurrency(value, currencyCode) {
    const n = Number(value);
    if (Number.isNaN(n)) return value;
    const currency = String(currencyCode || '').trim();
    const formatted = '$' + n.toLocaleString('en-US', {
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    if (currency) return `${formatted} ${currency}`;

    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n);
    } catch(e) {
      return '$' + n;
    }
  }

  // Semana Ganar Más: hora Colombia (UTC-5, sin horario de verano), de sábado a
  // sábado, sin depender de la zona horaria del navegador. Mismo cálculo que
  // betterware-co-backend (ganarMasWeek.ts), bwco-backend y bwco-widgets.
  const GANAR_MAS_UTC_OFFSET_HOURS = -5;
  const MS_PER_DAY = 86400000;

  function colombiaDateOnly(inputDate) {
    const shifted = new Date(inputDate.getTime() + GANAR_MAS_UTC_OFFSET_HOURS * 3600000);
    return new Date(Date.UTC(shifted.getUTCFullYear(), shifted.getUTCMonth(), shifted.getUTCDate()));
  }

  function startOfWeekSaturday(inputDate) {
    const offset = (inputDate.getUTCDay() - 6 + 7) % 7;
    return new Date(inputDate.getTime() - offset * MS_PER_DAY);
  }

  function startOfWeek1Saturday(year) {
    return startOfWeekSaturday(new Date(Date.UTC(year, 0, 1)));
  }

  function getCurrentWeek(inputDate) {
    const t = colombiaDateOnly(inputDate);
    const start = startOfWeekSaturday(t);
    let year = t.getUTCFullYear();
    let startYear = startOfWeek1Saturday(year);

    if (start < startYear) {
      year -= 1;
      startYear = startOfWeek1Saturday(year);
    } else {
      const startNextYear = startOfWeek1Saturday(year + 1);
      if (!(start < startNextYear)) {
        year += 1;
        startYear = startOfWeek1Saturday(year);
      }
    }

    const diffDays = Math.floor((start - startYear) / MS_PER_DAY);
    const week = Math.floor(diffDays / 7) + 1;
    const end = new Date(start.getTime() + 6 * MS_PER_DAY);

    return { week, year, start, end };
  }

  function extractNumericId(gid) {
    if (!gid) return '';
    const parts = String(gid).split('/');
    return parts[parts.length - 1] || '';
  }

  function initRoot(root) {
    if (!root || root.__ganarMasInitialized) return;

    const config = parseConfig(root);
    const isQuickOrder = !!config.isQuickOrder;
    const form = isQuickOrder ? null : resolveCartForm(root);
    const modal = root.querySelector('[data-ganamas-modal]');

    if (!modal) return;
    if (!isQuickOrder && !form) return;

    root.__ganarMasInitialized = true;

    const messages = config.messages || {};
    const message = function(key, fallback) {
      return typeof messages[key] !== 'undefined' ? messages[key] : (fallback || '');
    };

    let CUSTOMERID = isQuickOrder ? resolveQuickOrderCustomerId(config) : (config.customerId || null);
    const backdrop = modal.querySelector('[data-ganamas-backdrop]');
    const confirmBtn = modal.querySelector('.ganamas-confirm');
    const choices = Array.from(modal.querySelectorAll('.choice-btn'));
    const checkoutButtons = form ? Array.from(form.querySelectorAll('button[name="checkout"], input[name="checkout"], [data-ganamas-checkout]')) : [];
    const checkoutBtn = checkoutButtons.find(button => button.offsetParent !== null) || checkoutButtons[0] || null;
    const listSelector = '.ganamas-list';
    const chooseTitle = modal.querySelector('.ganamas-choose-title');
    const conditionsMessageSelector = modal.querySelector('.ganamas-conditions-subtitle');
    const beneficiaryEl = modal.querySelector('[data-ganamas-beneficiary]');
    const warningTextEl = modal.querySelector('[data-ganamas-warning-text]');
    const giftAmountEl = modal.querySelector('[data-ganamas-gift-amount]');

    let ganamasEligibility = null;
    let activeModalKind = null;
    let bypassSubmit = false;
    let checkoutLoading = false;
    let ganarMasSyncInProgress = false;
    let currentCartAttemptId = '';
    let availableGanarMasProducts = [];
    let availableGanarMasProductsKey = '';

    function setRandomChoiceVisible(isVisible) {
      modal.querySelectorAll('.ganamas-choices button[data-choice="random"]').forEach(button => {
        button.style.display = isVisible ? '' : 'none';
      });
    }

    function formatGiftPrice(value) {
      return formatCurrency(value, message('giftCurrency', 'USD'));
    }

    function updateGiftPriceMessages(ganarArr) {
      const amount = formatGiftPrice(ganarArr?.giftPrice ?? 0);

      if (giftAmountEl) {
        giftAmountEl.textContent = amount;
      }

      if (warningTextEl) {
        warningTextEl.textContent = interpolateMessage(
          message('availability', ''),
          { amount }
        );
      }
    }

    function getAvailableVariant(product) {
      const edges = product?.variants?.edges || [];
      return edges
        .map(edge => edge && edge.node)
        .find(variant => variant && Number(variant.inventoryQuantity) > 0) || null;
    }

    function normalizeAvailableProducts(products) {
      if (!Array.isArray(products)) return [];
      return products
        .map(product => ({
          product,
          variant: getAvailableVariant(product)
        }))
        .filter(item => item.product?.id && item.variant?.id);
    }

    function pickRandomGanarMasProduct() {
      if (!availableGanarMasProducts.length) {
        throw new Error('No Ganar Mas products available');
      }

      return availableGanarMasProducts[Math.floor(Math.random() * availableGanarMasProducts.length)];
    }

    function getBeneficiaryDisplayLabel(customerId) {
      const id = customerId || CUSTOMERID || '';
      if (isQuickOrder) {
        const fromWin = typeof window.GANARMAS_ASSOCIATE_DISPLAY_NAME === 'string' ? window.GANARMAS_ASSOCIATE_DISPLAY_NAME.trim() : '';
        if (fromWin) return fromWin;
        const el = document.querySelector('[data-js-purchase-order-partner-update-success-text]');
        const t = el && el.textContent ? el.textContent.trim() : '';
        return t || `Cliente ${id}`;
      }

      if (config.customerDisplayName) return config.customerDisplayName;
      return `Cliente ${id}`;
    }

    function hasAcceptedPprProduct(ganarArr) {
      return Array.isArray(ganarArr?.selectedProduct) && ganarArr.selectedProduct.length > 0;
    }

    function needsGiftModal(resp, ganarArr) {
      if (!resp || !ganarArr) return false;
      const noSelectedProduct = !hasAcceptedPprProduct(ganarArr);
      const currentSelectionStatus = resp.currentSelectionStatus || 'none';
      return (
        !!resp.eligible &&
        noSelectedProduct &&
        currentSelectionStatus !== 'omitted' &&
        ['none', 'equal'].includes(resp.status) &&
        Number(ganarArr.level) > 0
      );
    }

    function setConditionsMessage() {
      if (!conditionsMessageSelector) return;

      conditionsMessageSelector.innerHTML = isQuickOrder
        ? `<p>${message('associateCondition')}</p>`
        : `<p>${message('base')}</p>`;
    }

    function openGanamasModal() {
      const ganarArr = ganamasEligibility?.ganarMas?.[0] ?? {};
      updateGiftPriceMessages(ganarArr);
      setConditionsMessage();

      choices.forEach(c => c.classList.remove('choice-active'));
      if (chooseTitle) chooseTitle.classList.add('d-none');

      const container = modal.querySelector('.ganamas-list');
      if (container) container.innerHTML = '';

      modal.querySelectorAll('.ganamas-radio').forEach(r => { r.disabled = true; });
      setRandomChoiceVisible(availableGanarMasProducts.length > 0);

      if (confirmBtn) confirmBtn.disabled = true;
      if (beneficiaryEl) beneficiaryEl.textContent = getBeneficiaryDisplayLabel(CUSTOMERID);

      modal.classList.remove('d-none');
      modal.setAttribute('aria-hidden', 'false');
      activeModalKind = 'gift';
      document.body.style.overflow = 'hidden';

      const firstFocusable = modal.querySelector('.ganamas-cancel, .ganamas-confirm');
      if (firstFocusable) firstFocusable.focus();
    }

    async function prepareAndOpenGanamasModal(ganarArr) {
      const weeksWithSales = ganarArr.weeksWithSales;
      const level = ganarArr.level;

      availableGanarMasProducts = [];
      availableGanarMasProductsKey = '';
      setRandomChoiceVisible(true);

      try {
        const products = await loadAvailableGanarMasProducts(
          CUSTOMERID,
          level,
          weeksWithSales,
          true
        );
        setRandomChoiceVisible(products.length > 0);
      } catch (err) {
        availableGanarMasProducts = [];
        availableGanarMasProductsKey = '';
        setRandomChoiceVisible(false);
      }

      openGanamasModal();
      setCheckoutLoadingState(false);
      if (confirmBtn) confirmBtn.disabled = true;
    }

    function buildGanamasSelectionPayload(status, source) {
      const ganarData = (ganamasEligibility && Array.isArray(ganamasEligibility.ganarMas) && ganamasEligibility.ganarMas.length) ? ganamasEligibility.ganarMas[0] : {};
      const prev = getCurrentWeek(new Date());

      return {
        customerId: `${CUSTOMERID}`,
        productId: '',
        salesAmount: (ganarData && typeof ganarData.salesAmount !== 'undefined') ? Number(Number(ganarData.salesAmount).toFixed(2)) : 0,
        giftPrice: (ganarData && typeof ganarData.giftPrice !== 'undefined') ? ganarData.giftPrice : 0,
        weeksWithSales: (ganarData && typeof ganarData.weeksWithSales !== 'undefined') ? ganarData.weeksWithSales : 0,
        level: (ganarData && typeof ganarData.level !== 'undefined') ? ganarData.level : 0,
        week: prev.week,
        year: prev.year,
        status,
        source
      };
    }

    function closeGanamasModal() {
      modal.classList.add('d-none');
      modal.setAttribute('aria-hidden', 'true');
      if (activeModalKind === 'gift') activeModalKind = null;
      document.body.style.overflow = '';
      removeHiddenCheckout();
    }

    function addHiddenCheckout() {
      if (!form) return;
      if (!form.querySelector('input[name="checkout"]')) {
        const h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'checkout';
        h.value = '1';
        h.setAttribute('data-temporary-checkout', 'true');
        form.appendChild(h);
      }
    }

    function removeHiddenCheckout() {
      if (!form) return;
      const h = form.querySelector('input[name="checkout"][data-temporary-checkout]');
      if (h && h.parentNode) h.parentNode.removeChild(h);
    }

    function setCheckoutLoadingState(isLoading) {
      checkoutLoading = isLoading;
      if (!checkoutBtn) return;

      checkoutBtn.disabled = isLoading;
      checkoutBtn.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
      checkoutBtn.classList.toggle('btn--disabled', isLoading);
      checkoutBtn.classList.toggle('btn--loading', isLoading);
    }

    function confirmFlow() {
      setCheckoutLoadingState(true);
      addHiddenCheckout();
      bypassSubmit = true;
      closeGanamasModal();

      try {
        if (isQuickOrder) {
          document.dispatchEvent(new CustomEvent('ganarMas:continueCheckout'));
        } else {
          window.location.href = '/checkout';
        }
      } catch(e) {
        if (isQuickOrder) {
          document.dispatchEvent(new CustomEvent('ganarMas:continueCheckout'));
        } else {
          setTimeout(() => {
            if (!window.location.pathname.includes('/checkout')) {
              bypassSubmit = false;
              window.location.href = '/checkout';
            }
          }, 700);
        }
      }
    }

    async function fetchCartData() {
      const res = await fetch('/cart.js');
      if (!res.ok) {
        const txt = await res.text();
        throw new Error('Cart fetch failed: ' + res.status + ' - ' + txt);
      }
      return await res.json();
    }

    function isGanarMasCartItem(item) {
      const props = item?.properties || {};
      return props._ganar_mas === 'true' || props._ganar_mas === true;
    }

    function getGanarMasCartItemCustomerId(item) {
      const props = item?.properties || {};
      return String(props._ganar_mas_customer_id || '').trim();
    }

    function isCurrentCustomerGanarMasCartItem(item) {
      if (!isGanarMasCartItem(item)) return false;
      return (
        !!CUSTOMERID &&
        getGanarMasCartItemCustomerId(item) === String(CUSTOMERID)
      );
    }

    function isForeignGanarMasCartItem(item) {
      return isGanarMasCartItem(item) && !isCurrentCustomerGanarMasCartItem(item);
    }

    function getCurrentCustomerGanarMasCartItems(cart) {
      return (cart?.items || []).filter(isCurrentCustomerGanarMasCartItem);
    }

    async function notifyQuickOrderCartSynced() {
      if (!isQuickOrder) return;

      try {
        const cart = await fetchCartData();
        document.dispatchEvent(new CustomEvent('ganarMas:cartSynced', {
          detail: { cart },
          bubbles: true
        }));
      } catch(e) {
        document.dispatchEvent(new CustomEvent('ganarMas:cartSynced', {
          detail: {},
          bubbles: true
        }));
      }
    }

    // Estado de comisión por línea (key -> 'true' | 'false' | 'unknown') que
    // dibuja Liquid en cart-line-items (etiqueta del producto o del padre del set).
    async function fetchCartCommissionStates() {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}?section_id=api-cart-items-readonly`, {
        signal: AbortSignal.timeout(20000)
      });
      if (!response.ok) throw new Error(`Ganar Mas cart commission tags failed: ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const states = new Map();
      doc.querySelectorAll('[data-ganar-mas-line-key]').forEach(el => {
        states.set(el.dataset.ganarMasLineKey, el.dataset.ganarMasExcluded);
      });
      return states;
    }

    // Monto Ganar Más: subtotal sin Ganar Más ni no comisionables. Si no se
    // conoce la etiqueta de una línea, la línea cuenta: nunca se bloquea el pago
    // por una regla de Ganar Más.
    async function getCartAmount(cart) {
      let commissionStates = new Map();
      try {
        commissionStates = await fetchCartCommissionStates();
      } catch (err) {
        console.warn('[GANAMAS] Commission tags unavailable; all cart lines count for Ganar Mas', err);
      }
      const excludedSubtotal = (cart?.items || []).reduce((sum, item) => {
        const linePrice = Number(item.final_line_price || item.line_price || 0) || 0;
        if (isGanarMasCartItem(item)) return sum + linePrice;
        const state = commissionStates.get(item.key);
        if (state !== 'true' && state !== 'false') {
          console.warn('[GANAMAS] Commission tags unknown; cart line counts for Ganar Mas', item.key);
        }
        return state === 'true' ? sum + linePrice : sum;
      }, 0);
      const subtotal = Number(cart.items_subtotal_price || 0) - excludedSubtotal;
      return Math.max(subtotal, 0) / 100;
    }

    function getCartAttemptId(cart) {
      return String(cart?.token || '').trim();
    }

    function getOmittedAttemptStorageKey(customerId) {
      return `ganarMas:omitted:${String(customerId || '').trim()}`;
    }

    function getOmittedAttempt(customerId) {
      try {
        return sessionStorage.getItem(getOmittedAttemptStorageKey(customerId)) || '';
      } catch (err) {
        return '';
      }
    }

    function setOmittedAttempt(customerId, attemptId) {
      if (!customerId || !attemptId) return;
      try {
        sessionStorage.setItem(getOmittedAttemptStorageKey(customerId), attemptId);
      } catch (err) {}
    }

    function clearOmittedAttempt(customerId) {
      if (!customerId) return;
      try {
        sessionStorage.removeItem(getOmittedAttemptStorageKey(customerId));
      } catch (err) {}
    }

    async function fetchEligibility(week, year, cartAmount) {
      const payload = {
        week,
        year,
        source: 'first',
        customers: [{
          customerId: CUSTOMERID,
          cartAmount: `${cartAmount}`
        }]
      };
      const url = `${AWS_API_URL}/Prod/ganar-mas/calculate`;
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      if (!res.ok) {
        const txt = await res.text();
        throw new Error('Eligibility fetch failed: ' + res.status + ' - ' + txt);
      }
      return await res.json();
    }

    async function postSelection(payload) {
      const url = `${AWS_API_URL}/Prod/ganar-mas`;
      try {
        const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        if (!res.ok) {
          const txt = await res.text();
          console.warn('postSelection warning', res.status, txt);
          return null;
        }
        return await res.json();
      } catch(e) {
        console.warn('postSelection error', e);
        return null;
      }
    }

    async function fetchGanaMasProductsForUser(customerId, level, weeksWithSales) {
      const url = `${AWS_API_URL}/Prod/ganar-mas/products/${encodeURIComponent(customerId)}?level=${level}&weeksWithSales=${weeksWithSales}`;
      const res = await fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
      if (!res.ok) {
        const txt = await res.text();
        throw new Error('Products fetch failed: ' + res.status + ' - ' + txt);
      }
      return await res.json();
    }

    async function loadAvailableGanarMasProducts(customerId, level, weeksWithSales, force) {
      const key = `${customerId}:${level}:${weeksWithSales}`;
      if (!force && availableGanarMasProductsKey === key) return availableGanarMasProducts;

      const products = await fetchGanaMasProductsForUser(customerId, level, weeksWithSales);
      availableGanarMasProducts = normalizeAvailableProducts(products);
      availableGanarMasProductsKey = key;
      safeLog('Available Ganar Mas products loaded', {
        customerId,
        level,
        weeksWithSales,
        count: availableGanarMasProducts.length
      });

      return availableGanarMasProducts;
    }

    async function addGanarMasProductToCart(selection, payload) {
      const productId = extractNumericId(selection?.product?.id);
      const variantId = extractNumericId(selection?.variant?.id);

      if (!productId || !variantId) {
        throw new Error('Selected Ganar Mas product does not have a valid product or variant id');
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            _ganar_mas: 'true',
            _ganar_mas_customer_id: `${CUSTOMERID}`,
            _ganar_mas_product_id: productId,
            _ganar_mas_level: `${payload.level}`,
            _ganar_mas_weeks_with_sales: `${payload.weeksWithSales}`,
            _ganar_mas_week: `${payload.week}`,
            _ganar_mas_year: `${payload.year}`,
            _ganar_mas_sales_amount: `${payload.salesAmount}`
          }
        })
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error('Ganar Mas cart add failed: ' + res.status + ' - ' + txt);
      }

      safeLog('Ganar Mas product added to cart', {
        productId,
        variantId,
        level: payload.level,
        weeksWithSales: payload.weeksWithSales
      });

      return {
        productId,
        variantId,
        response: await res.json()
      };
    }

    async function removeGanarMasCartItems(cartData, keepKey, filterFn) {
      const cart = cartData || await fetchCartData();
      const shouldRemove = typeof filterFn === 'function' ? filterFn : isGanarMasCartItem;
      const items = (cart?.items || []).filter(item => {
        return shouldRemove(item) && (!keepKey || item.key !== keepKey);
      });

      if (!items.length) return 0;

      for (const item of items) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });

        if (!res.ok) {
          const txt = await res.text();
          throw new Error('Ganar Mas cart remove failed: ' + res.status + ' - ' + txt);
        }
      }

      safeLog('Ganar Mas products removed from cart', { count: items.length, kept: keepKey || null });
      return items.length;
    }

    async function removeCurrentCustomerGanarMasCartItems(cartData, keepKey) {
      const removed = await removeGanarMasCartItems(cartData, keepKey, isCurrentCustomerGanarMasCartItem);
      if (removed) await notifyQuickOrderCartSynced();
      return removed;
    }

    async function removeForeignGanarMasCartItems(cartData) {
      const removed = await removeGanarMasCartItems(
        cartData,
        null,
        isForeignGanarMasCartItem
      );
      if (removed) await notifyQuickOrderCartSynced();
      return removed;
    }

    function hasPendingGanarMasOrderProduct() {
      const orders = Array.isArray(ganamasEligibility?.pendingGanarMasOrders)
        ? ganamasEligibility.pendingGanarMasOrders
        : [];

      return orders.some(order => {
        const lineItems = Array.isArray(order.lineItems) ? order.lineItems : [];
        return lineItems.length > 0;
      });
    }

    function getGanarMasCartItemNumber(item, property) {
      const value = Number(item?.properties?.[property]);
      return Number.isFinite(value) ? value : 0;
    }

    function getExpectedGanarMasSalesAmount(ganarArr) {
      const value = Number(ganarArr?.salesAmount || 0);
      return Number.isFinite(value) ? Number(value.toFixed(2)) : 0;
    }

    function getPayloadGanarMasSalesAmount(payload) {
      const value = Number(payload?.salesAmount || 0);
      return Number.isFinite(value) ? Number(value.toFixed(2)) : 0;
    }

    function hasCurrentGanarMasSalesAmount(item, expectedAmount) {
      const currentAmount = Number(item?.properties?._ganar_mas_sales_amount || 0);
      if (!Number.isFinite(currentAmount)) return false;
      return Number(currentAmount.toFixed(2)) === Number(expectedAmount || 0);
    }

    async function updateGanarMasCartItemSalesAmount(item, salesAmount) {
      if (!item?.key || !salesAmount) return false;

      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity || 1,
          properties: {
            ...(item.properties || {}),
            _ganar_mas_sales_amount: `${salesAmount}`
          }
        })
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error('Ganar Mas cart properties update failed: ' + res.status + ' - ' + txt);
      }

      safeLog('Ganar Mas cart sales amount updated', {
        key: item.key,
        salesAmount
      });
      return true;
    }

    function isAllowedGanarMasCartItem(item, ganarArr, period) {
      const assignedLevel = getGanarMasCartItemNumber(item, '_ganar_mas_level');
      const allowedLevel = Number(ganarArr?.level) || 0;
      const assignedWeeksWithSales = getGanarMasCartItemNumber(
        item,
        '_ganar_mas_weeks_with_sales'
      );
      const allowedWeeksWithSales = Number(ganarArr?.weeksWithSales) || 0;
      const assignedWeek = getGanarMasCartItemNumber(item, '_ganar_mas_week');
      const assignedYear = getGanarMasCartItemNumber(item, '_ganar_mas_year');

      return (
        assignedLevel > 0 &&
        allowedLevel > 0 &&
        assignedLevel === allowedLevel &&
        assignedWeeksWithSales > 0 &&
        assignedWeeksWithSales === allowedWeeksWithSales &&
        assignedWeek === Number(period.week) &&
        assignedYear === Number(period.year)
      );
    }

    async function validateCurrentCartGanarMasItems(cart, ganarArr, period) {
      const currentItems = getCurrentCustomerGanarMasCartItems(cart);
      if (!currentItems.length) return { kept: false, removed: 0 };
      const expectedSalesAmount = getExpectedGanarMasSalesAmount(ganarArr);

      const itemToKeep = currentItems.find(item => {
        return isAllowedGanarMasCartItem(item, ganarArr, period);
      });
      const removed = await removeCurrentCustomerGanarMasCartItems(
        cart,
        itemToKeep?.key
      );
      let updated = false;

      if (
        itemToKeep &&
        expectedSalesAmount > 0 &&
        !hasCurrentGanarMasSalesAmount(itemToKeep, expectedSalesAmount)
      ) {
        updated = await updateGanarMasCartItemSalesAmount(itemToKeep, expectedSalesAmount);
      }

      safeLog('Ganar Mas cart products validated', {
        found: currentItems.length,
        kept: itemToKeep?.key || null,
        removed,
        updated,
        allowedLevel: Number(ganarArr?.level) || 0,
        allowedWeeksWithSales: Number(ganarArr?.weeksWithSales) || 0,
        salesAmount: expectedSalesAmount
      });

      return {
        kept: !!itemToKeep,
        removed
      };
    }

    function isSameGanarMasBenefit(item, payload) {
      const props = item?.properties || {};
      return (
        String(props._ganar_mas_level || '') === String(payload.level) &&
        String(props._ganar_mas_weeks_with_sales || '') === String(payload.weeksWithSales) &&
        String(props._ganar_mas_week || '') === String(payload.week) &&
        String(props._ganar_mas_year || '') === String(payload.year)
      );
    }

    async function syncGanarMasSelectionToCart(payload, forceReplace) {
      if (ganarMasSyncInProgress) {
        throw new Error('Ganar Mas cart sync already in progress');
      }

      ganarMasSyncInProgress = true;

      try {
        const cart = await fetchCartData();
        const currentItems = getCurrentCustomerGanarMasCartItems(cart);
        const currentItem = currentItems[0];
        const currentProductId = currentItem?.properties?._ganar_mas_product_id || '';

        if (currentItems.length > 1) {
          safeLog('Duplicate Ganar Mas cart products detected', { count: currentItems.length });
        }

        if (currentItem && !forceReplace && isSameGanarMasBenefit(currentItem, payload) && currentProductId) {
          if (currentItems.length > 1) {
            await removeCurrentCustomerGanarMasCartItems(cart, currentItem.key);
          }

          const expectedSalesAmount = getPayloadGanarMasSalesAmount(payload);
          if (
            expectedSalesAmount > 0 &&
            !hasCurrentGanarMasSalesAmount(currentItem, expectedSalesAmount)
          ) {
            await updateGanarMasCartItemSalesAmount(currentItem, expectedSalesAmount);
          }

          safeLog('Ganar Mas cart product kept', {
            productId: currentProductId,
            level: payload.level,
            weeksWithSales: payload.weeksWithSales,
            week: payload.week,
            year: payload.year,
            salesAmount: expectedSalesAmount
          });
          return {
            productId: String(currentProductId),
            kept: true
          };
        }

        if (currentItems.length) {
          await removeCurrentCustomerGanarMasCartItems(cart);
        }

        await loadAvailableGanarMasProducts(CUSTOMERID, payload.level, payload.weeksWithSales, true);
        const selected = pickRandomGanarMasProduct();
        const added = await addGanarMasProductToCart(selected, payload);
        await notifyQuickOrderCartSynced();
        return added;
      } finally {
        ganarMasSyncInProgress = false;
      }
    }

    async function onConfirmGanamas() {
      if (!confirmBtn || confirmBtn.disabled) return;
      confirmBtn.disabled = true;

      try {
        const active = choices.find(c => c.classList.contains('choice-active'));
        const choiceVal = active ? active.getAttribute('data-choice') : '';
        if (!choiceVal) {
          confirmBtn.disabled = false;
          return;
        }

        const payload = buildGanamasSelectionPayload('pending', 'first');

        if (choiceVal === 'none') {
          payload.productId = '';
          payload.status = 'omitted';
          await removeCurrentCustomerGanarMasCartItems();
          await postSelection([payload]).catch(() => {});
          setOmittedAttempt(CUSTOMERID, currentCartAttemptId);
          confirmFlow();
          return;
        }

        if (choiceVal === 'random') {
          const added = await syncGanarMasSelectionToCart(payload, true);

          payload.productId = added.productId;
          payload.status = 'select';
          await postSelection([payload]).catch(() => {});
          clearOmittedAttempt(CUSTOMERID);
          confirmFlow();
          return;
        }

        confirmBtn.disabled = false;
      } catch(err) {
        console.error('Error en onConfirmGanamas:', err);
        alert('Ocurrió un error, intenta nuevamente.');
        confirmBtn.disabled = false;
      }
    }

    async function onCheckoutClick(e) {
      if (bypassSubmit || checkoutLoading) return;
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      CUSTOMERID = isQuickOrder ? resolveQuickOrderCustomerId(config) : (config.customerId || null);
      if (!CUSTOMERID) {
        confirmFlow();
        return;
      }

      setCheckoutLoadingState(true);

      try {
        // Pedido rápido ya evaluó Regalón antes de emitir ganarMas:calculate.
        if (!isQuickOrder) {
          await window.RegalonCheckout?.prepare({ customerId: CUSTOMERID });
        }
        const cart = await fetchCartData();
        await removeForeignGanarMasCartItems(cart);
        currentCartAttemptId = getCartAttemptId(cart);
        const cartAmount = await getCartAmount(cart);
        const prev = getCurrentWeek(new Date());
        const eligibility = await fetchEligibility(prev.week, prev.year, cartAmount);
        ganamasEligibility = eligibility && eligibility.length > 0 ? eligibility[0].response : null;
        const ganarArr = ganamasEligibility?.ganarMas?.[0] ?? {};
        if (
          ganamasEligibility?.currentSelectionStatus === 'omitted' &&
          getOmittedAttempt(CUSTOMERID) !== currentCartAttemptId
        ) {
          ganamasEligibility.currentSelectionStatus = 'none';
          ganarArr.selectedProduct = [];
        }
        const hasExistingOrderBenefit =
          ganamasEligibility?.currentSelectionStatus === 'sent' ||
          hasPendingGanarMasOrderProduct();

        if (hasExistingOrderBenefit) {
          try {
            await removeCurrentCustomerGanarMasCartItems();
          } catch (err) {
            console.error('Error removing duplicate Ganar Mas cart product:', err);
            setCheckoutLoadingState(false);
            alert('Ocurrió un error actualizando tu producto Ganar Más, intenta nuevamente.');
            return;
          }
          confirmFlow();
          return;
        }

        if (!ganamasEligibility?.eligible) {
          const payload = buildGanamasSelectionPayload('omitted', 'eligibility-sync');
          payload.productId = '';
          try {
            await removeCurrentCustomerGanarMasCartItems();
          } catch (err) {
            console.error('Error removing ineligible Ganar Mas product:', err);
            setCheckoutLoadingState(false);
            alert('Ocurrió un error actualizando tu producto Ganar Más, intenta nuevamente.');
            return;
          }
          await postSelection([payload]).catch(() => {});
          confirmFlow();
          return;
        }

        const cartValidation = await validateCurrentCartGanarMasItems(
          cart,
          ganarArr,
          prev
        );
        if (cartValidation.kept) {
          confirmFlow();
          return;
        }

        if (cartValidation.removed > 0) {
          ganamasEligibility.currentSelectionStatus = 'none';
          ganarArr.selectedProduct = [];
          await prepareAndOpenGanamasModal(ganarArr);
          return;
        }

        if (needsGiftModal(ganamasEligibility, {
          ...ganarArr,
          selectedProduct: []
        })) {
          await prepareAndOpenGanamasModal(ganarArr);
          return;
        }

        confirmFlow();
      } catch(err) {
        console.error('Error checking Ganamas eligibility:', err);
        setCheckoutLoadingState(false);
        confirmFlow();
      }
    }

    choices.forEach(choice => {
      choice.addEventListener('click', function() {
        choices.forEach(x => x.classList.remove('choice-active'));
        this.classList.add('choice-active');

        const choiceVal = this.getAttribute('data-choice');
        const container = modal.querySelector(listSelector);

        if (choiceVal === 'random') {
          if (chooseTitle) chooseTitle.classList.add('d-none');
          //if (container) container.innerHTML = '<div style="padding:20px; text-align:center">Se seleccionará un producto aleatorio.</div>';
          if (confirmBtn) confirmBtn.disabled = false;
          return;
        }

        if (chooseTitle) chooseTitle.classList.add('d-none');
        //if (container) container.innerHTML = '<div style="padding:20px; text-align:center">No se añadirá ningún producto.</div>';
        if (confirmBtn) confirmBtn.disabled = false;
      });
    });

    function cancelFlow() {
      removeHiddenCheckout();
      bypassSubmit = false;
      setCheckoutLoadingState(false);
      closeGanamasModal();
      if (checkoutBtn) checkoutBtn.focus();
    }

    if (backdrop) {
      backdrop.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      });
    }

    checkoutButtons.forEach(button => {
      if (button.__ganamasBound) return;
      button.addEventListener('click', onCheckoutClick, { capture: true });
      button.__ganamasBound = true;
    });

    if (confirmBtn && !confirmBtn.__ganamasConfirmBound) {
      confirmBtn.addEventListener('click', onConfirmGanamas);
      confirmBtn.__ganamasConfirmBound = true;
    }

    if (form && !form.__ganamasSubmitBound) {
      form.addEventListener('submit', function(e) {
        if (bypassSubmit || !config.customerId) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        onCheckoutClick(e);
      }, { capture: true });
      form.__ganamasSubmitBound = true;
    }

    if (isQuickOrder && !root.__ganamasQuickOrderBound) {
      window.__ganarMasQuickOrderReady = true;
      document.addEventListener('ganarMas:calculate', function(e) {
        CUSTOMERID = resolveQuickOrderCustomerId(config);
        if (!CUSTOMERID) {
          confirmFlow();
          return;
        }

        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        onCheckoutClick(e);
      });
      root.__ganamasQuickOrderBound = true;
    }

    document.addEventListener('ganarMas:orderCompleted', function(e) {
      const completedCustomerId = String(e?.detail?.customerId || CUSTOMERID || '').trim();
      clearOmittedAttempt(completedCustomerId);
    });

    document.addEventListener('keydown', function(e) {
      if (!activeModalKind) return;
      if (e.key === 'Escape') {
        cancelFlow();
      }
    });

    safeLog('Ganamas modal script initialized', { isQuickOrder: isQuickOrder });
  }

  function initAll() {
    document.querySelectorAll('[data-ganamas-root]').forEach(initRoot);
  }

  window.__initGanarMas = initAll;
  initAll();
})();
